import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  ExciseLicenceRequestListPayload,
  IListaKategorijeIVrsteObveznikaZaDozvoluProps,
  ISviZahteviZaDozvoluProps,
  IVracanjeDodatnihInformacijaZaKreiranjeDozvoleProps,
  IZahtevDozvole,
  IZahtevDozvoleEdit,
} from "./exciseLicences.types";

const getListaKategorijeIVrsteObveznikaZaDozvolu = (): Promise<
  ApiResponseObject<IListaKategorijeIVrsteObveznikaZaDozvoluProps>
> => {
  return axios.get("/listaKategorijeIVrsteObveznikaZaDozvolu");
};

const getSviZahteviZaDozvolu = (
  payload: ExciseLicenceRequestListPayload
): Promise<ApiResponseObject<ISviZahteviZaDozvoluProps>> => {
  return axios.post("/sviZahteviZaDozvolu", payload);
};

const postVracanjeDodatnihInformacijaZaKreiranjeDozvole = (
  skladisteId: number | null
): Promise<
  ApiResponseObject<IVracanjeDodatnihInformacijaZaKreiranjeDozvoleProps>
> => {
  return axios.post("/vracanjeDodatnihInformacijaZaKreiranjeDozvole", {
    skladisteId,
  });
};

const postKreiranjeZahtevaDozvole = (
  payload: IZahtevDozvole
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/kreiranjeZahtevaDozvole", payload);
};

const updateIzmenaZahtevaDozvole = (
  payload: IZahtevDozvoleEdit
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/izmenaZahtevaDozvole", payload);
};

export const exciseLicencesRepo = {
  getListaKategorijeIVrsteObveznikaZaDozvolu,
  getSviZahteviZaDozvolu,
  postVracanjeDodatnihInformacijaZaKreiranjeDozvole,
  postKreiranjeZahtevaDozvole,
  updateIzmenaZahtevaDozvole,
};
